import { Component, Input } from "@angular/core";

import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@Component({
    selector: "app-spinner",
    templateUrl: "./spinner.component.html",
    imports: [MatProgressSpinnerModule],
})
export class SpinnerComponent {
    @Input() isLoading: boolean;
    @Input() diameter: string = "40";
    @Input() spinnerColor: string = "#0066B2";
    @Input() loadingText: string = "Loading..."
    @Input() showText: boolean = true;
}
